import { createSelector } from 'reselect';
import moment from 'moment-timezone';
import get from 'lodash/get';
import birdChartSelector, {
  sliceIntervalSelector,
} from '@store/errorDiagnostics/birdChart/selectors';
import { getColor, granularity as tGranularity } from '@utils';
import { getIntervalByGranularity } from '@utils/granularity';
import { scrollingWindowByStore } from '@utils/scrollingWindowFromTo';

import { SCOPE } from './types';

const selector = (state) => get(state, SCOPE);

export default selector;

export const intervalSelector = createSelector(selector, scrollingWindowByStore);

export const intervalPayloadSelector: any = createSelector(
  intervalSelector,
  sliceIntervalSelector,
  (interval, sliceInterval) => {
    // eslint-disable-next-line prefer-const
    let { from, to, shortcut } = interval;
    if (sliceInterval.from && sliceInterval.to) {
      from = moment(sliceInterval.from).startOf('minute').toISOString();
      to = moment(sliceInterval.to).startOf('minute').toISOString();
    }
    return scrollingWindowByStore({ interval: { from, to, shortcut } });
  },
);

export const errorCodesSelector = createSelector(selector, (store) =>
  get(store, 'errorCodeSelected', []),
);

export const currentErrorCodeSelector = createSelector(selector, (store) =>
  get(store, 'currentErrorCode', ''),
);

export const filterColorsSelector = createSelector(selector, (store) =>
  get(store, 'errorCodeSelected', {}).map((errorCode, index) => getColor(index, errorCode)),
);

export const metricSelector = createSelector(selector, (store) => get(store, 'metric', ''));

export const filterSelector = createSelector(selector, (store) => get(store, 'filter', []));

export const birdChartIntervalSelector = createSelector(
  birdChartSelector,
  intervalPayloadSelector,
  (errorBirdChartStore, intervalStore) => {
    let zoomIntervalObj = {};
    const { zoomIntervalStart, zoomIntervalEnd } = errorBirdChartStore;
    if (!zoomIntervalStart && !zoomIntervalEnd) {
      zoomIntervalObj = {
        from: intervalStore.from,
        to: intervalStore.to,
      };
    } else {
      zoomIntervalObj = {
        from: zoomIntervalStart,
        to: zoomIntervalEnd,
      };
    }
    const granularity = tGranularity(zoomIntervalStart, zoomIntervalEnd, true);
    const { from, to } = getIntervalByGranularity(zoomIntervalObj, granularity);
    return {
      interval: `${from}/${to}`,
    };
  },
);
